// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__1qARG","content":"styles_content__2ltlA","checkbox":"styles_checkbox__2I8HQ","checkboxLabel":"styles_checkboxLabel__DTTfU"};